import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import Styled from 'styled';

import _ from './feed-filter.graphql';
import { PostType } from './feed-filter.graphql.types';
import defaultStyles from './feed-filter.scss';

interface Props {
    styles: typeof defaultStyles;
    user: any;
    postType?: PostType;
    albumsCount?: number | null;
    articlesCount?: number | null;
}

class FeedFilter extends React.PureComponent<Props> {
    render() {
        const { styles, user, postType, albumsCount, articlesCount } = this.props;

        const link = user.profile.isVendor ? `/catalog/vendor/${user.username}/` : `/blog/${user.username}/`;

        return (
            <div className={styles.container}>
                <NavLink
                    to={link}
                    exact
                    isActive={() => !postType}
                    className={styles.button}
                    activeClassName={styles.active}
                >
                    <FormattedMessage id='PHOTOBLOGS_ALL' />
                </NavLink>
                <NavLink
                    to={`${link}?post_type=${'POST_SHORT_MESSAGE'}`}
                    isActive={() => postType === 'POST_SHORT_MESSAGE'}
                    className={styles.button}
                    activeClassName={styles.active}
                >
                    <FormattedMessage id='SHORT_MESSAGES_TITLE' />
                </NavLink>
                {albumsCount ? (
                    <NavLink
                        to={`${link}?post_type=${'POST_ALBUM'}`}
                        isActive={() => postType === 'POST_ALBUM'}
                        className={styles.button}
                        activeClassName={styles.active}
                    >
                        <FormattedMessage id='ALBUMS_TITLE' />
                    </NavLink>
                ) : null}
                {articlesCount ? (
                    <NavLink
                        to={`${link}?post_type=${'POST_ARTICLE'}`}
                        isActive={() => postType === 'POST_ARTICLE'}
                        className={styles.button}
                        activeClassName={styles.active}
                    >
                        <FormattedMessage id='ARTICLES_TITLE' />
                    </NavLink>
                ) : null}
            </div>
        );
    }
}

export default Styled(defaultStyles)(FeedFilter);
